import { Fragment } from "react";

import { StyledTokenChip } from "./styled";

/**
 * Splits on {{token}} so the interpolation placeholders understood by
 * `helpers/interpolate` render as chips instead of raw braces.
 */
const TOKEN_PATTERN = /(\{\{.*?\}\})/g;

export function TokenText({ value }: { value?: string }) {
  if (!value) {
    return null;
  }

  return (
    <>
      {value.split(TOKEN_PATTERN).map((segment, index) => {
        const isToken = TOKEN_PATTERN.test(segment);
        TOKEN_PATTERN.lastIndex = 0;

        if (!isToken) {
          // eslint-disable-next-line react/no-array-index-key
          return <Fragment key={index}>{segment}</Fragment>;
        }

        return (
          // eslint-disable-next-line react/no-array-index-key
          <StyledTokenChip key={index}>
            {segment.replace(/[{}]/g, "")}
          </StyledTokenChip>
        );
      })}
    </>
  );
}
